/**
 * API service for the network reference (primary, backups, active L0) and the manual handover
 */

import { NetworkReference, NetworkReferenceUpdate } from '../types/references';
import httpClient from './httpClient';

const api = httpClient;

export const networkApi = {
  async getNetworkReference(): Promise<NetworkReference> {
    const response = await api.get<NetworkReference>('/network/reference');
    return response.data;
  },

  // admin only
  async setNetworkReference(update: NetworkReferenceUpdate): Promise<NetworkReference> {
    const response = await api.put<NetworkReference>('/network/reference', update);
    return response.data;
  },

  // admin and operator; 409 with the reasons when the target is not usable and force is false
  async activate(deviceId: number, force: boolean): Promise<NetworkReference> {
    const response = await api.post<NetworkReference>('/network/reference/activate', { device_id: deviceId, force });
    return response.data;
  },
};

export default networkApi;
